import { Component, ChangeDetectionStrategy, ElementRef, ViewChild, Output, EventEmitter } from '@angular/core';
import { IBOMCopy } from '../../../enclosure/models/bom-copy.model';

import { DocumentTypesComponent } from '../document-types/document-types.component';

// eslint-disable-next-line @typescript-eslint/no-explicit-any, no-var
declare var jQuery: any;

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-bom-copy-modal',
    templateUrl: './bom-copy-modal.component.html',
    styleUrls: ['./bom-copy-modal.component.scss'],
    standalone: false
})
export class BomCopyModalComponent {

  @ViewChild('bomCopyModal') bomCopyModalEl: ElementRef;
  @ViewChild('BOMDescription') bomDescription: DocumentTypesComponent;

  selectedOption = 0;

  @Output() copyOptionSelected = new EventEmitter<IBOMCopy>();
  @Output() showInfoForCopyToClipboard = new EventEmitter<void>();
  @Output() directDelivery = new EventEmitter<void>();

  onConfirm() {
    if (this.selectedOption === 3) {
      this.directDelivery.emit();
      return;
    }
    if (this.selectedOption !== 1) {
      this.showInfoForCopyToClipboard.emit();
    }

    this.copyOptionSelected.emit({
      selectedOption: this.selectedOption,
      title: this.bomDescription.value
    });
  }

  openModal() {
    jQuery(this.bomCopyModalEl.nativeElement).modal('show');
  }

  closeModal() {
    (document.activeElement as HTMLElement)?.blur();
    jQuery(this.bomCopyModalEl.nativeElement).modal('hide');
    this.setSelectionToDefault();
  }

  setSelectionToDefault() {
    this.selectedOption = 0;
  }

  selectOption(option: number) {
    this.selectedOption = option;
  }
}
